module.exports = "<template> <div class=tyl-stepper part=root> <slot></slot> </div> </template>";